import { useEffect, useState } from "react";
import { getLatestErasmusNews } from "../services/erasmusService";

export const useLatestErasmusPost = () => {
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const data = await getLatestErasmusNews({
          signal: controller.signal
        });

        setPost(data);
      } catch (error) {
        if (error.name !== "AbortError") {
          setError(error);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => controller.abort();
  }, []);

  return {
    post,
    isLoading,
    error
  };
};